import ImageBarcodeReader from "./components/ImageBarcodeReader";
import StreamBarcodeReader from "./components/StreamBarcodeReader";

export { ImageBarcodeReader, StreamBarcodeReader };



//////////////////
// WEBPACK FOOTER
// ./~/vue-barcode-reader/src/index.js
// module id = 394
// module chunks = 0